import { useQuery, UseQueryResult, useMutation, UseMutationResult } from '@tanstack/react-query'
import { getRfpByToken, downloadRfpPdf, getPublicRfpById, downloadRfpPdfPublic } from 'proposals/api/procurementApiClient'
import { AxiosResponse } from 'axios'

export const useGetRequestForProposalByTokenQuery = (token: string): UseQueryResult<RequestForProposalResponseType> => {
  return useQuery<RequestForProposalResponseType>({
    queryKey: ['rfp', token],
    queryFn: () => getRfpByToken(token),
    refetchOnWindowFocus: false
  })
}

export const useGetRequestForProposalPdfQuery = (): UseMutationResult<AxiosResponse<string>, unknown, string, unknown> => {
  return useMutation({
    mutationFn: (rfpId: string) => downloadRfpPdf(rfpId)
  })
}

export const useGetRequestForProposalPublicPdfQuery = (): UseMutationResult<AxiosResponse<string>, unknown, string, unknown> => {
  return useMutation({
    mutationFn: (uniqueToken: string) => downloadRfpPdfPublic(uniqueToken)
  })
}

export const useGetPublicRequestForProposalByIdQuery = (
  uniqueToken: string, 
  options: { enabled?: boolean } = {}
): UseQueryResult<RequestForProposalType> => {
  return useQuery<RequestForProposalType>({
    queryKey: ['rfp-public', uniqueToken],
    queryFn: () => getPublicRfpById(uniqueToken),
    refetchOnWindowFocus: false,
    enabled: options.enabled ?? true
  })
}